function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import pathOr from 'ramda/src/pathOr';
import clone from 'ramda/src/clone';
import moment from 'moment';
import { stateGo, stateReload } from 'redux-ui-router';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import { CanUserUpdatePinSelector, CreateCustomerStateRegionProvinceValueOptions, CurrentCustomerAccountingMethodSelector, CurrentCustomerBillCycleSelector, CurrentCustomerChargeTypeForDetailedTaxationSelector, CurrentCustomerExternalAuthorizationsSelector, CurrentCustomerHomeCountryNameSelector, CurrentCustomerIdSelector, CurrentCustomerInvoiceDetailStatus, CurrentCustomerNewBillCycleSelector, CurrentCustomerAdjustmentDueDaysSelector, CurrentCustomerPaymentDueDaysSelector, CurrentCustomerSelector, CurrentCustomerSubscriberCurrencyNameSelector, CurrentCustomerSubscriberPreferredTaxReportingCurrencySelector, CurrentCustomerSubtenantSelector, CustomerContactPreferencesSelector, CustomerIsFetchingDataSelector, CustomerPinRegexSelector, CustomerPreferredMethodOfContactSelector, IsPIIDataAccessEnabledSelector, IsCreatingCustomerSelector, IsCurrentCustomerHierarchyRootOrNotInHierarchySelector, IsSelectedCustomerWithPinSelector, SelectedCustomerAdditionalPropertiesSortedByDisplayOrderSelector, SelectedCustomerConsentsMandatorySelector, SelectedCustomerConsentsMandatoryUnacceptedSelector, SelectedCustomerConsentsOptionalSelector, SelectedCustomerRequirements, ViewLastAttemptErrorSelector } from '../../../reducers/selectors/customer.selectors';
import { ContactMethodOptionsSelector, CurrentCustomerProfileMoreMenuItemsSelector, InvoiceDisplaySelector, HomeCountriesStatesSelector, NotificationPreferencesSelector, SelectedTaxLevelExemptionsSelector, SubscriberIdentificationsSelector, TaxAssociationCodesSelector, TaxCategoryExemptionsSelector, TaxExemptionTypeCodesSelector, TaxLevelCodesSelector } from '../../createCustomerPopup/customer.form.dropdown.selectors';
import { CustomerInfoSelector } from '../orders/create/offer/add.offer.wizard.selectors';
import { clearCreateEditCustomerForm, createEditCustomerFormChanged, deleteExternalAuthorization, resendVerificationEmail, retrieveCustomer, searchSubtenants, setCustomerCategory, setIsEditingProfile, updateSubscriber, updateSubscriberBillCycle, updateSubscriberPIN } from '../../../reducers/actions/customer.actions';
import { registerUnsavedChanges, unregisterUnsavedChanges } from 'invision-core/src/components/unsavedChangesPrompt/actions';
import { hasAccess, hasAdminAccess } from 'invision-core/src/components/security/permission.service';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { BILLING_CONFIGURATION_TYPES } from 'invision-core/src/components/metadata/billingConfiguration/billing.configuration.action.types';
import { subscriberOrderTypeEnum } from 'invision-core/src/utilities/subscriber.order.type.enum';
import { BillingConfigurationLoadedSelector } from 'invision-core/src/components/metadata/billingConfiguration/billing.configuration.selectors';
import { MetadataActions } from 'invision-core';
import { fetchCodeTypes, fetchExternalAuthorizationProviders, fetchConsents, fetchTaxLevels } from 'invision-core/src/components/metadata/codes/codes.actions';
import i18n from 'invision-core/src/components/i18n/i18n';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { MetadataCodeLoadedSelector, MetadataCodeTypeSelector, SubscriberRequirementsForCurrentBusinessUnitOrDefault, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CUSTOMER_CATEGORY } from '../../createCustomerPopup/create.customer.popup.constants';
import { INVOICE_DETAIL_LEVEL, NOTIFICATION_TIME_LENGTH } from '../../../customercare.constants';
import { getNameByCountryCode } from '../customer.helper';
import CustomerCareLocaleKeys from '../../../locales/keys';
import { EMAIL_VERIFICATION_STATUS, PROFILE_ACTIVE_STATUS, PROFILE_ANONYMIZED_STATUS, PROFILE_EVENTS, PROFILE_OPTION_REACTIVATE_ID, PROFILE_OPTION_SCHEDULE_ANONYMIZATION_ID, PROFILE_OPTION_ANONYMIZE_IMMEDIATELY_ID, PROFILE_REMOVED_STATUS } from './profile.constants';
import { ADDRESS_ACCESS, ANONYMIZE_SUBSCRIBER_IMMEDIATELY_ACCESS, BILL_CYCLE_CHANGE_ACCESS, SUBSCRIBER_ADMIN_ACCESS, SUBSCRIBER_TYPE_EDIT_ACCESS } from '../../../security.attributes';
import { loadSubscriberRequirements } from '../../../reducers/helpers/subscriber.requirements.actions.helper';
import { IsLoadingInventoryItemsSelector } from '../../../reducers/selectors/customer.inventory.selectors';
import { IsFetchingAccountStatusDataSelector } from '../../../reducers/selectors/customer.account.status.selectors';
import { CurrentBusinessUnitHasSubtenants } from '../../../reducers/selectors/subtenant.selectors';
import { SelectedCustomerAddressSelector } from '../../../reducers/selectors/products.order.selectors';
import { BillCycleDetailsSelector, CandidateBillCyclesSelector, IsRetrievingBillCycleDetailsSelector, NewBillCycleDetailsSelector } from '../../../reducers/selectors/customer.billcycle.selectors';
import { retrieveBillCycleDetails, retrieveCandidateBillCycles, retrieveNextBillCycleDetails } from '../../../reducers/actions/customer.billcycle.actions';
import { getEditCustomerModel } from './profile.helper';
import { IsCreditCheckEnabledSelector, IsCreditCheckSuccessSelector, IsMatchSubscriberCreditCheckDetailsSelector, SubscriberCreditCheckDetailsSelector, SubscriberCreditClassificationStatusSelector } from '../../../reducers/selectors/credit.check.selectors';
import { performCreditCheck } from '../../../reducers/actions/credit.check.actions';
import { CREDIT_CHECK_STATUS } from '../../../reducers/constants/credit.check.constants';
import { SubtenantsLoadedSelector } from 'invision-core/src/components/subtenants/subtenants.selectors';
import { FormattedEditCustomerSubscriberIdentitiesSelector } from '../../../reducers/selectors/customer.information.selectors';
import { ACCOUNTING_METHODS } from '../../../components/createCustomer/billingInformationSection/billing.information.section.constants';
import { CUSTOMER_STATE } from '../../shared/constants/customer.constants';
import { REPORTING_LEVELS } from '../accountHierarchy/account.hierarchy.constants';
export var CustomerProfileController = /*#__PURE__*/function () {
  function CustomerProfileController($ngRedux, $q, $scope, $stateParams, $timeout, uiNotificationService) {
    var _this = this;
    _classCallCheck(this, CustomerProfileController);
    _defineProperty(this, "onCreateCustomerModalError", function (error) {
      _this.uiNotificationService.transientError(error);
      _this.showEditCustomerModal = false;
    });
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $q: $q,
      $scope: $scope,
      $stateParams: $stateParams,
      $timeout: $timeout,
      CreditCheckStatus: CREDIT_CHECK_STATUS,
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      CustomerCategory: CUSTOMER_CATEGORY,
      CUSTOMER_STATE: CUSTOMER_STATE,
      editCustomerFormErrors: [],
      EMAIL_VERIFICATION_STATUS: EMAIL_VERIFICATION_STATUS,
      emailVerificationStatus: null,
      isAccountingMethodEditable: false,
      isBillCycleChangeAllowed: false,
      isDataLoaded: false,
      notificationPreferencesSection: [],
      onCustomerBillingDetailsUpdateModal: this.onCustomerBillingDetailsUpdateModal.bind(this),
      onSubmitCustomerPinModal: this.onSubmitCustomerPinModal.bind(this),
      callRetrieveSubscriber: this.callRetrieveSubscriber.bind(this),
      canUserEdit: this.canUserEdit.bind(this),
      closeEditCustomerModal: this.closeEditCustomerModal.bind(this),
      closeCreditCheckModal: this.closeCreditCheckModal.bind(this),
      isResidentialCustomer: this.isResidentialCustomer.bind(this),
      getAccountingMethod: this.getAccountingMethod.bind(this),
      onCreateCustomerModalError: this.onCreateCustomerModalError.bind(this),
      onSubmitEditCustomerModal: this.onSubmitEditCustomerModal.bind(this),
      saveCreditCheckModal: this.saveCreditCheckModal.bind(this),
      PROFILE_ACTIVE_STATUS: PROFILE_ACTIVE_STATUS,
      REPORTING_LEVELS: REPORTING_LEVELS,
      requirements: {},
      showLoadingIndicator: false,
      showEditCustomerModal: false,
      showCreditCheckModal: false,
      stateOrName: 'index.customercare.customer.profile',
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(CustomerProfileController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      this.$scope.$on(PROFILE_EVENTS.OPEN_EDIT_CUSTOMER_MODAL, function () {
        _this2.openEditProfileInformationPopup(_this2.state.currentCustomer);
      });
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          adjustmentDueDays: CurrentCustomerAdjustmentDueDaysSelector(store),
          billCycleDetails: BillCycleDetailsSelector(store),
          candidateBillCycles: CandidateBillCyclesSelector(store),
          canUserUpdatePin: CanUserUpdatePinSelector(store),
          contactEvents: MetadataCodeTypeSelector(CODES.ContactEvent, store),
          contactEventsLoaded: MetadataCodeLoadedSelector(CODES.ContactEvent, store),
          contactMapping: MetadataCodeTypeSelector(CODES.ContactMapping, store),
          contactMappingLoaded: MetadataCodeLoadedSelector(CODES.ContactMapping, store),
          contactMethodOptions: ContactMethodOptionsSelector(store),
          contactMethods: MetadataCodeTypeSelector(CODES.ContactMethod, store),
          contactMethodsLoaded: MetadataCodeLoadedSelector(CODES.ContactMethod, store),
          createCustomerDriversLicenseStateOptions: CreateCustomerStateRegionProvinceValueOptions(store),
          currentBusinessUnitHasSubtenants: CurrentBusinessUnitHasSubtenants(store),
          currentAddresses: SelectedCustomerAddressSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerAdditionalProperties: SelectedCustomerAdditionalPropertiesSortedByDisplayOrderSelector(store),
          currentCustomerBillCycle: CurrentCustomerBillCycleSelector(store),
          currentCustomerChargeTypeForDetailedTaxation: CurrentCustomerChargeTypeForDetailedTaxationSelector(store),
          currentCustomerConsentsMandatory: SelectedCustomerConsentsMandatorySelector(store),
          currentCustomerConsentsMandatoryUnaccepted: SelectedCustomerConsentsMandatoryUnacceptedSelector(store),
          currentCustomerConsentsOptional: SelectedCustomerConsentsOptionalSelector(store),
          currentCustomerContactPreferences: CustomerContactPreferencesSelector(store),
          currentCustomerExternalAuthorizations: CurrentCustomerExternalAuthorizationsSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentCustomerNewBillCycle: CurrentCustomerNewBillCycleSelector(store),
          currentCustomerPreferredMethodOfContact: CustomerPreferredMethodOfContactSelector(store),
          currentCustomerSubtenant: CurrentCustomerSubtenantSelector(store),
          currentCustomerAccountingMethod: CurrentCustomerAccountingMethodSelector(store),
          customerInfo: CustomerInfoSelector(store),
          externalAuthorizationProviders: MetadataCodeTypeSelector(CODES.ExternalAuthorizationProvider, store),
          formattedEditCustomerSubscriberIdentities: FormattedEditCustomerSubscriberIdentitiesSelector(store),
          homeCountries: MetadataCodeTypeSelector(CODES.AddressCountry, store),
          homeCountriesLoaded: MetadataCodeLoadedSelector(CODES.AddressCountry, store),
          homeCountriesStates: HomeCountriesStatesSelector(store),
          homeCountriesStatesLoaded: MetadataCodeLoadedSelector(CODES.AddressStateProvinceRegion, store),
          homeCountryName: CurrentCustomerHomeCountryNameSelector(store),
          invoiceDetailStatus: CurrentCustomerInvoiceDetailStatus(store),
          invoiceDisplays: InvoiceDisplaySelector(store),
          isBillCycleLoaded: BillingConfigurationLoadedSelector(BILLING_CONFIGURATION_TYPES.BILL_CYCLES_CODE, store),
          isPIIDataAccessEnabled: IsPIIDataAccessEnabledSelector(store),
          isConsentsLoaded: MetadataCodeLoadedSelector(CODES.Consents, store),
          isCreatingCustomer: IsCreatingCustomerSelector(store),
          isCreditCheckEnabled: IsCreditCheckEnabledSelector(store),
          isCreditCheckSuccess: IsCreditCheckSuccessSelector(store),
          isCurrentCustomerHierarchyRootOrNotInHierarchy: IsCurrentCustomerHierarchyRootOrNotInHierarchySelector(store),
          isDbss: IsDbss(store),
          isExternalAuthorizationLoaded: MetadataCodeLoadedSelector(CODES.ExternalAuthorizationProvider, store),
          isFetchingAccountStatusData: IsFetchingAccountStatusDataSelector(store),
          isFetchingData: CustomerIsFetchingDataSelector(store),
          isInvoiceDetailsLevelsLoaded: MetadataCodeLoadedSelector(CODES.InvoiceDetailLevel, store),
          isInvoiceDisplayLoaded: BillingConfigurationLoadedSelector(BILLING_CONFIGURATION_TYPES.INVOICE_DISPLAY_CODE, store),
          isLoadingInventory: IsLoadingInventoryItemsSelector(store),
          isMatchSubscriberCreditCheckDetails: IsMatchSubscriberCreditCheckDetailsSelector(store),
          isRetrievingBillCycleDetails: IsRetrievingBillCycleDetailsSelector(store),
          isSelectedCustomerWithPin: IsSelectedCustomerWithPinSelector(store),
          isTaxExemptionCodeLoaded: BillingConfigurationLoadedSelector(BILLING_CONFIGURATION_TYPES.TAX_EXEMPTION_CATEGORY_CODE, store),
          isTaxLevelCodesLoaded: MetadataCodeLoadedSelector(CODES.TaxLevel, store),
          isTaxTypeAssociationCodeLoaded: BillingConfigurationLoadedSelector(BILLING_CONFIGURATION_TYPES.TAX_ASSOCICATION_CODE, store),
          isTaxTypeCodesLoaded: BillingConfigurationLoadedSelector(BILLING_CONFIGURATION_TYPES.TAX_EXEMPTION_TYPE_CODE, store),
          languages: MetadataCodeTypeSelector(CODES.Language, store),
          languagesLoaded: MetadataCodeLoadedSelector(CODES.Language, store),
          lastAttemptError: ViewLastAttemptErrorSelector(store),
          moreOptionsMenuItems: CurrentCustomerProfileMoreMenuItemsSelector(store),
          notificationCategoryPreference: NotificationPreferencesSelector(store),
          newBillCycleDetails: NewBillCycleDetailsSelector(store),
          paymentDueDays: CurrentCustomerPaymentDueDaysSelector(store),
          personGenderCodes: MetadataCodeTypeSelector(CODES.PersonGender, store),
          personRaceCodes: MetadataCodeTypeSelector(CODES.PersonRace, store),
          pinRegex: CustomerPinRegexSelector(store),
          selectedCustomerRequirements: SelectedCustomerRequirements(store),
          subscriberCategoryRequirements: SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault(store),
          subscriberCreditCheckDetails: SubscriberCreditCheckDetailsSelector(store) || {},
          subscriberCreditClassificationStatus: SubscriberCreditClassificationStatusSelector(store),
          subscriberCurrencies: MetadataCodeTypeSelector(CODES.Currency, store),
          subscriberCurrenciesLoaded: MetadataCodeLoadedSelector(CODES.Currency, store),
          subscriberCurrencyName: CurrentCustomerSubscriberCurrencyNameSelector(store),
          subscriberPreferredReportingTaxCurrencyName: CurrentCustomerSubscriberPreferredTaxReportingCurrencySelector(store),
          subscriberIdentifications: SubscriberIdentificationsSelector(store),
          subscriberIdentificationsLoaded: MetadataCodeLoadedSelector(CODES.SubscriberIdentifications, store),
          subscriberIncomeLevelTypeCodes: MetadataCodeTypeSelector(CODES.SubscriberIncomeLevelType, store),
          subscriberLeadSourceTypeCodes: MetadataCodeTypeSelector(CODES.SubscriberLeadSourceType, store),
          subscriberRequirements: SubscriberRequirementsForCurrentBusinessUnitOrDefault(store),
          subscriberTypeCodes: MetadataCodeTypeSelector(CODES.SubscriberType, store),
          subTenantsLoaded: SubtenantsLoadedSelector(store),
          taxAssociationCodes: TaxAssociationCodesSelector(store),
          taxCategoryExemptions: TaxCategoryExemptionsSelector(store),
          taxExemptionTypes: TaxExemptionTypeCodesSelector(store),
          taxLevelCodes: TaxLevelCodesSelector(store),
          taxLevelExemptions: SelectedTaxLevelExemptionsSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      var controllerActions = {
        clearCreateEditCustomerForm: clearCreateEditCustomerForm,
        createEditCustomerFormChanged: createEditCustomerFormChanged,
        deleteExternalAuthorization: deleteExternalAuthorization,
        fetchCodeType: fetchCodeTypes,
        fetchExternalAuthorizationProviders: fetchExternalAuthorizationProviders,
        getConsents: fetchConsents,
        getInvoiceDisplay: MetadataActions.billingConfiguration.getInvoiceDisplay,
        getTaxAssociationCodes: MetadataActions.billingConfiguration.getTaxAssociationCodes,
        getTaxExemptionCategories: MetadataActions.billingConfiguration.getTaxExemptionCategories,
        getTaxExemptionTypes: MetadataActions.billingConfiguration.getTaxExemptionTypes,
        getTaxLevelCodes: fetchTaxLevels,
        loadSubscriberRequirements: loadSubscriberRequirements,
        performCreditCheck: performCreditCheck,
        registerUnsavedChanges: registerUnsavedChanges,
        resendVerificationEmail: resendVerificationEmail,
        retrieveBillCycleDetails: retrieveBillCycleDetails,
        retrieveCandidateBillCycles: retrieveCandidateBillCycles,
        retrieveCustomer: retrieveCustomer,
        retrieveNextBillCycleDetails: retrieveNextBillCycleDetails,
        searchSubtenants: searchSubtenants,
        setCustomerCategory: setCustomerCategory,
        setIsEditingProfile: setIsEditingProfile,
        stateGo: stateGo,
        stateReload: stateReload,
        unregisterUnsavedChanges: unregisterUnsavedChanges,
        updateSubscriber: updateSubscriber,
        updateSubscriberBillCycle: updateSubscriberBillCycle,
        updateSubscriberPIN: updateSubscriberPIN
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      this.actions.fetchExternalAuthorizationProviders();
      this.actions.loadSubscriberRequirements().then(function () {
        _this2.requirements = _this2.state.currentCustomer.Category === CUSTOMER_CATEGORY.RESIDENTIAL ? _this2.state.subscriberRequirements : _this2.state.subscriberCategoryRequirements;
        _this2.isDataLoaded = true;
      });
      if (!this.state.isConsentsLoaded) {
        this.actions.getConsents();
      }
      if (!this.state.notificationCategoryPreference.length) {
        this.actions.fetchCodeType(CODES.NotificationCategories).then(function () {
          _this2.formatNotificationPreferences();
        });
      } else {
        this.formatNotificationPreferences();
      }
      if (this.state.isDbss) {
        if (!this.state.isInvoiceDetailsLevelsLoaded) {
          this.actions.fetchCodeType(CODES.InvoiceDetailLevel);
        }
        if (!this.state.isTaxTypeCodesLoaded) {
          this.actions.getTaxExemptionTypes();
        }
        if (!this.state.isTaxLevelCodesLoaded) {
          this.actions.getTaxLevelCodes();
        }
        if (!this.state.homeCountriesLoaded) {
          this.actions.fetchCodeType(CODES.AddressCountry);
        }
        if (!this.state.subscriberCurrenciesLoaded) {
          this.actions.fetchCodeType(CODES.Currency);
        }
        this.actions.searchSubtenants().then(function () {}).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
        });
        if (!this.state.contactMethodsLoaded) {
          this.actions.fetchCodeType(CODES.ContactMethod);
        }
        if (!this.state.contactEventsLoaded) {
          this.actions.fetchCodeType(CODES.ContactEvent);
        }
        if (!this.state.contactMappingLoaded) {
          this.actions.fetchCodeType(CODES.ContactMapping);
        }
        if (!this.state.subscriberIdentificationsLoaded) {
          this.actions.fetchCodeType(CODES.SubscriberIdentifications).then(function () {
            _this2.formatSubscriberIdentifications();
          });
        } else {
          this.formatSubscriberIdentifications();
        }
        if (!this.state.isTaxTypeAssociationCodeLoaded) {
          this.actions.getTaxAssociationCodes();
        }
        this.actions.fetchCodeType(CODES.FeatureToggleConfig);
      }
      this.triggerResendEmail = function () {
        _this2.actions.resendVerificationEmail(_this2.state.currentCustomer.Id).then(function () {
          _this2.uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.PROFILE_PAGE.VERIFICATION_EMAIL_SENT_SUCCESS));
        });
      };
      this.removeAuthErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.removeAuthErrorPopupApi = event.api;
        }
      };
      this.optionalParams = {
        customerId: this.state.currentCustomerId
      };
      this._retrieveCustomer(true).then(function () {
        _this2.setCustomerTypeChangeReadOnly();
        _this2.actions.setCustomerCategory(_this2.state.currentCustomer.Category);
        if (_this2.state.currentCustomerBillCycle) {
          _this2.actions.retrieveBillCycleDetails(_this2.state.currentCustomerBillCycle);
        }
        if (_this2.state.currentCustomerNewBillCycle) {
          _this2.actions.retrieveNextBillCycleDetails(_this2.state.currentCustomerNewBillCycle);
        }
        if (_this2.state.isDbss) {
          _this2.actions.retrieveCandidateBillCycles(_this2.state.currentCustomerId, subscriberOrderTypeEnum.postpaid.value).then(function () {
            if (_this2.state.currentCustomer.HierarchyId) {
              _this2.isBillCycleChangeAllowed = !_this2.state.currentCustomer.HierarchyParentSubscriberId;
            } else if (_this2.state.currentCustomer.HouseholdMemberPrivileges) {
              _this2.isBillCycleChangeAllowed = false;
            } else {
              _this2.isBillCycleChangeAllowed = true;
            }
          }).catch(function (error) {
            _this2.uiNotificationService.transientError(error.translatedMessage);
          });
        }
      }).then(function () {
        if (!_this2.state.subscriberCreditCheckDetails.isLoaded || !_this2.state.isMatchSubscriberCreditCheckDetails) {
          _this2.actions.performCreditCheck(null, _this2.state.currentCustomerId);
        }
      });
      this.loadBillingConfigurations();
      this.unsavedChangesPromptPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this2.unsavedChangesPromptPopupApi = api;
        }
      };
      this.customerPinPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this2.customerPinPopupApi = api;
        }
      };
      this.creditCheckPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref3) {
          var api = _ref3.api;
          _this2.creditCheckPopupApi = api;
        }
      };
      this.mandatoryConsentsPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref4) {
          var api = _ref4.api;
          _this2.mandatoryConsentsPopupApi = api;
        }
      };
      this.customerBillingCycleUpdateConfig = {
        onRegisterApi: function onRegisterApi(_ref5) {
          var api = _ref5.api;
          _this2.customerBillingCycleUpdatePopupApi = api;
        }
      };
      if (!this.state.languagesLoaded) {
        this.actions.fetchCodeType(CODES.Language);
      }
      this.$timeout(function () {
        if (_this2.$stateParams.openEditCustomerModal) {
          _this2.$stateParams.openEditCustomerModal = false;
          _this2.openEditProfileInformationPopup(_this2.state.currentCustomer);
        }
        if (_this2.state.currentCustomer.EmailVerificationExpiration) {
          _this2.emailVerificationStatus = moment(_this2.state.currentCustomer.EmailVerificationExpiration).isBefore(moment()) ? EMAIL_VERIFICATION_STATUS.SUSPENDED : EMAIL_VERIFICATION_STATUS.PENDING_APPROVAL;
          _this2.tooltipTemplate = require('./status.tooltip.template.html');
        }
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.editProfileInformationPopupApi.close();
      this.disconnectRedux();
    }
  }, {
    key: "onChangedCreateCustomerForm",
    value: function onChangedCreateCustomerForm(customerModel) {
      this.actions.createEditCustomerFormChanged(customerModel);
    }
  }, {
    key: "openEditProfileInformationPopup",
    value: function openEditProfileInformationPopup(profileInformation) {
      this.showEditCustomerModal = true;
    }
  }, {
    key: "closeEditCustomerModal",
    value: function closeEditCustomerModal() {
      this.showEditCustomerModal = false;
    }
  }, {
    key: "isResidentialCustomer",
    value: function isResidentialCustomer() {
      return this.state.customerInfo.Category === CustomerCategory.RESIDENTIAL;
    }
  }, {
    key: "getAccountingMethod",
    value: function getAccountingMethod() {
      var _ACCOUNTING_METHODS$t;
      return ACCOUNTING_METHODS === null || ACCOUNTING_METHODS === void 0 ? void 0 : (_ACCOUNTING_METHODS$t = ACCOUNTING_METHODS[this.state.currentCustomerAccountingMethod]) === null || _ACCOUNTING_METHODS$t === void 0 ? void 0 : _ACCOUNTING_METHODS$t.id;
    }
  }, {
    key: "onSubmitEditCustomerModal",
    value: function onSubmitEditCustomerModal() {
      var _this3 = this;
      this.showEditCustomerModal = false;
      this.uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.PROFILE_PAGE.UPDATE_SUCCESS_MESSAGE), null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
      this.$timeout(function () {
        _this3.actions.stateReload().then(function () {
          _this3.showLoadingIndicator = false;
        });
      });
    }
  }, {
    key: "openCustomerPinPopup",
    value: function openCustomerPinPopup() {
      var _this4 = this;
      this.showCustomerPinPopup = true;
      this.$timeout(function () {
        _this4.customerPinPopupApi.open();
      });
    }
  }, {
    key: "closeCustomerPinPopup",
    value: function closeCustomerPinPopup() {
      this.showCustomerPinPopup = false;
      this.customerPinPopupApi.close();
    }
  }, {
    key: "openCustomerBillingCycleUpdatePopup",
    value: function openCustomerBillingCycleUpdatePopup() {
      var _this5 = this;
      this.showCustomerBillingCycleUpdatePopup = true;
      this.isAccountingMethodEditable = (this.state.currentCustomer ? !this.state.currentCustomer.HierarchyParentSubscriberId : true) && (this.CUSTOMER_STATE.PROSPECT_LITE === convertStringToNumber(this.state.currentCustomer.State) || this.CUSTOMER_STATE.PROSPECT === convertStringToNumber(this.state.currentCustomer.State));
      this.$timeout(function () {
        _this5.customerBillingCycleUpdatePopupApi.open();
      });
    }
  }, {
    key: "closeCustomerBillingCycleUpdatePopup",
    value: function closeCustomerBillingCycleUpdatePopup() {
      this.showCustomerBillingCycleUpdatePopup = false;
      this.customerBillingCycleUpdatePopupApi.close();
    }
  }, {
    key: "handleResultRemoveAuthErrorPopup",
    value: function handleResultRemoveAuthErrorPopup() {
      this.removeAuthErrorPopupApi.close();
    }
  }, {
    key: "handleCloseRemoveAuthErrorPopup",
    value: function handleCloseRemoveAuthErrorPopup() {
      this.removeAuthErrorPopupApi.close();
    }
  }, {
    key: "loadBillingConfigurations",
    value: function loadBillingConfigurations() {
      if (this.state.isDbss) {
        if (!this.state.isInvoiceDisplayLoaded) {
          this.actions.getInvoiceDisplay();
        }
        if (!this.state.isTaxExemptionCodeLoaded) {
          this.actions.getTaxExemptionCategories();
        }
      }
    }
  }, {
    key: "canUserEdit",
    value: function canUserEdit() {
      return hasAdminAccess(this.state.userSecurityAttributes, SUBSCRIBER_ADMIN_ACCESS) && this.state.currentCustomer.State !== PROFILE_ANONYMIZED_STATUS && this.state.isPIIDataAccessEnabled;
    }
  }, {
    key: "canUserRemove",
    value: function canUserRemove() {
      return hasAdminAccess(this.state.userSecurityAttributes, SUBSCRIBER_ADMIN_ACCESS) && !this.state.currentCustomer.ConvergentBillerId;
    }
  }, {
    key: "canUserAnonymizeImmediately",
    value: function canUserAnonymizeImmediately() {
      return hasAccess(this.state.userSecurityAttributes, ANONYMIZE_SUBSCRIBER_IMMEDIATELY_ACCESS);
    }
  }, {
    key: "hasAddressAdminAccess",
    value: function hasAddressAdminAccess() {
      return hasAdminAccess(this.state.userSecurityAttributes, ADDRESS_ACCESS);
    }
  }, {
    key: "isBillingDetailsEditable",
    value: function isBillingDetailsEditable() {
      var _this$state$currentCu, _this$state$currentCu2;
      return hasAccess(this.state.userSecurityAttributes, BILL_CYCLE_CHANGE_ACCESS) && !((_this$state$currentCu = this.state.currentCustomer) !== null && _this$state$currentCu !== void 0 && (_this$state$currentCu2 = _this$state$currentCu.SubscriberTypeDetails) !== null && _this$state$currentCu2 !== void 0 && _this$state$currentCu2.BillCycleChangeInProgress);
    }
  }, {
    key: "isCreditClassificationExpired",
    get: function get() {
      return this.CreditCheckStatus.EXPIRED === this.state.subscriberCreditClassificationStatus;
    }
  }, {
    key: "getBooleanLocaleKey",
    value: function getBooleanLocaleKey(value) {
      return value ? CustomerCareLocaleKeys.YES : CustomerCareLocaleKeys.NO;
    }
  }, {
    key: "onDeleteExternalAuthorization",
    value: function onDeleteExternalAuthorization(externalAuthId) {
      var _this6 = this;
      this.actions.deleteExternalAuthorization(this.state.currentCustomer, externalAuthId).then(function () {
        _this6.uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.PROFILE_PAGE.DELETE_AUTH_SUCCESS_MESSAGE), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      }).catch(function () {
        _this6.removeAuthErrorPopupApi.open();
      });
    }
  }, {
    key: "updateCustomerStatus",
    value: function updateCustomerStatus(status) {
      var _this7 = this;
      this.handleCloseScheduleAnonymizationPopup();
      var customer = this.state.currentCustomer.asMutable({
        deep: true
      });
      customer.Status = status;
      this.actions.updateSubscriber(customer).then(function () {
        if (status === PROFILE_REMOVED_STATUS) {
          _this7.uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.PROFILE_PAGE.REMOVE_SUCCESS_MESSAGE), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        }
        if (status === PROFILE_ACTIVE_STATUS) {
          _this7.uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.PROFILE_PAGE.REACTIVATE_SUCCESS_MESSAGE), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        }
        _this7._retrieveCustomer();
      }).catch(function () {
        _this7.uiNotificationService.error(i18n.translate(CustomerCareLocaleKeys.PROFILE_PAGE.REMOVE_FAILURE_MESSAGE), _this7.state.lastAttemptError.translatedMessage, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      });
    }
  }, {
    key: "callRetrieveSubscriber",
    value: function callRetrieveSubscriber() {
      this.actions.retrieveCustomer(this.state.currentCustomerId);
      this.actions.stateReload();
    }
  }, {
    key: "onSubmitCustomerPinModal",
    value: function onSubmitCustomerPinModal(subscriberPIN) {
      var _this8 = this;
      this.actions.updateSubscriberPIN(subscriberPIN, this.state.currentCustomerId).then(function () {
        _this8.actions.retrieveCustomer(_this8.state.currentCustomerId);
        _this8.uiNotificationService.success(i18n.translate(_this8.state.isSelectedCustomerWithPin ? CustomerCareLocaleKeys.PROFILE_PAGE.CUSTOMER_PIN_UPDATED : CustomerCareLocaleKeys.PROFILE_PAGE.CUSTOMER_PIN_CREATED), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      }).catch(function (error) {
        _this8.uiNotificationService.transientError(error.translatedMessage);
      });
      this.closeCustomerPinPopup();
    }
  }, {
    key: "updateSubscriber",
    value: function updateSubscriber(selectedBillCycleId, paymentDueDays, adjustmentDueDays, updatedAccountingMethod) {
      var _this9 = this;
      var customer = clone(this.state.currentCustomer);
      if (customer.SubscriberTypeDetails) {
        customer.SubscriberTypeDetails.BillCycle = selectedBillCycleId;
        customer.SubscriberTypeDetails.PaymentDueDays = paymentDueDays;
        customer.SubscriberTypeDetails.AdjustmentDueDays = adjustmentDueDays;
        customer.SubscriberTypeDetails.AccountingMethod = updatedAccountingMethod;
      }
      return this.actions.updateSubscriber(customer).then(function () {
        _this9.actions.retrieveCustomer(_this9.state.currentCustomerId).then(function () {
          _this9.retrieveCandidateBillCyclesForCustomer().then(function () {
            _this9.uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.PROFILE_PAGE.CUSTOMER_BILLING_DETAILS_UPDATED), null, {
              timeOut: NOTIFICATION_TIME_LENGTH
            });
          });
        });
        _this9.closeCustomerBillingCycleUpdatePopup();
      }).catch(function (error) {
        _this9.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "onCustomerBillingDetailsUpdateModal",
    value: function onCustomerBillingDetailsUpdateModal(selectedBillCycle, paymentDueDays, adjustmentDueDays, updatedAccountingMethod) {
      var _this$state$currentCu3,
        _this$state$currentCu4,
        _this$state$currentCu5,
        _this$state$currentCu6,
        _this$state$currentCu7,
        _this$state$currentCu8,
        _this10 = this;
      var updateSubscriber = paymentDueDays !== null && paymentDueDays !== ((_this$state$currentCu3 = this.state.currentCustomer) === null || _this$state$currentCu3 === void 0 ? void 0 : (_this$state$currentCu4 = _this$state$currentCu3.SubscriberTypeDetails) === null || _this$state$currentCu4 === void 0 ? void 0 : _this$state$currentCu4.PaymentDueDays) || adjustmentDueDays !== null && adjustmentDueDays !== ((_this$state$currentCu5 = this.state.currentCustomer) === null || _this$state$currentCu5 === void 0 ? void 0 : (_this$state$currentCu6 = _this$state$currentCu5.SubscriberTypeDetails) === null || _this$state$currentCu6 === void 0 ? void 0 : _this$state$currentCu6.AdjustmentDueDays) || updatedAccountingMethod !== null && updatedAccountingMethod !== ((_this$state$currentCu7 = this.state.currentCustomer) === null || _this$state$currentCu7 === void 0 ? void 0 : (_this$state$currentCu8 = _this$state$currentCu7.SubscriberTypeDetails) === null || _this$state$currentCu8 === void 0 ? void 0 : _this$state$currentCu8.AccountingMethod);
      if (selectedBillCycle !== null && selectedBillCycle !== void 0 && selectedBillCycle.id && this.state.currentCustomerBillCycle !== selectedBillCycle.id) {
        this.actions.updateSubscriberBillCycle(selectedBillCycle.id, this.state.currentCustomerId).then(function () {
          if (updateSubscriber) {
            return _this10.updateSubscriber(selectedBillCycle.id, paymentDueDays, adjustmentDueDays, updatedAccountingMethod);
          } else {
            return _this10.actions.retrieveCustomer(_this10.state.currentCustomerId).then(function () {
              return _this10.actions.retrieveBillCycleDetails(_this10.state.currentCustomerBillCycle).then(function () {
                _this10.uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.PROFILE_PAGE.CUSTOMER_BILL_CYCLE_UPDATED), null, {
                  timeOut: NOTIFICATION_TIME_LENGTH
                });
                _this10.closeCustomerBillingCycleUpdatePopup();
              });
            });
          }
        }).catch(function (error) {
          _this10.uiNotificationService.transientError(error.translatedMessage);
          _this10.closeCustomerBillingCycleUpdatePopup();
        });
      } else if (updateSubscriber) {
        this.updateSubscriber(this.state.currentCustomerBillCycle, paymentDueDays, adjustmentDueDays, updatedAccountingMethod);
      }
    }
  }, {
    key: "retrieveCandidateBillCyclesForCustomer",
    value: function retrieveCandidateBillCyclesForCustomer() {
      var _this11 = this;
      if (this.state.currentCustomerBillCycle) {
        this.actions.retrieveBillCycleDetails(this.state.currentCustomerBillCycle);
      }
      return this.actions.retrieveCandidateBillCycles(this.state.currentCustomerId, subscriberOrderTypeEnum.postpaid.value).then(function () {
        if (_this11.state.currentCustomer.HierarchyId) {
          _this11.isBillCycleChangeAllowed = !(_this11.state.currentCustomer && _this11.state.currentCustomer.HierarchyParentSubscriberId);
        } else if (_this11.state.currentCustomer.HouseholdMemberPrivileges) {
          _this11.isBillCycleChangeAllowed = false;
        } else {
          _this11.isBillCycleChangeAllowed = true;
        }
      });
    }
  }, {
    key: "isStacked",
    value: function isStacked() {
      return pathOr(0, ['currentCustomer', 'AdditionalProperties', 'length'], this.state) <= 3;
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      this.editCustomerFormErrors = [];
      this.showEditProfileInformationPopup = false;
      this.editProfileInformationForm.$setPristine();
      this.editProfileInformationForm.$setUntouched();
    }
  }, {
    key: "handleResultUnsavedChangesPromptPopup",
    value: function handleResultUnsavedChangesPromptPopup(confirmed) {
      confirmed && this.unsavedChangesPromptConfirmCallback();
      this.unsavedChangesPromptConfirmCallback = null;
      this.unsavedChangesPromptPopupApi.close();
    }
  }, {
    key: "handleCloseUnsavedChangesPromptPopup",
    value: function handleCloseUnsavedChangesPromptPopup() {
      this.unsavedChangesPromptPopupApi.close();
    }
  }, {
    key: "getBillCycleBillDate",
    value: function getBillCycleBillDate() {
      return this.state.billCycleDetails.billDate ? i18n.translate(CustomerCareLocaleKeys.PROFILE_PAGE.NEXT_BILL_DATE, {
        billDate: this.state.billCycleDetails.billDate
      }) : i18n.translate(CustomerCareLocaleKeys.PROFILE_PAGE.DATE_UNAVAILABLE);
    }
  }, {
    key: "getInvoiceDisplay",
    value: function getInvoiceDisplay() {
      var _this12 = this;
      var selectedInvoiceDisplay = this.state.invoiceDisplays.find(function (invoiceDisplay) {
        return invoiceDisplay.Value === pathOr('Default', ['SubscriberTypeDetails', 'InvoiceDisplay'], _this12.state.currentCustomer);
      });
      return pathOr('', ['Name'], selectedInvoiceDisplay);
    }
  }, {
    key: "getInvoiceDetailLevel",
    value: function getInvoiceDetailLevel() {
      switch (this.state.currentCustomer.InvoiceConfiguration.InvoiceDetailLevel) {
        case INVOICE_DETAIL_LEVEL.DETAIL:
          return i18n.translate(CustomerCareLocaleKeys.INVOICE_DETAIL_LEVEL_OPTIONS.DETAIL);
        case INVOICE_DETAIL_LEVEL.SUMMARY:
          return i18n.translate(CustomerCareLocaleKeys.INVOICE_DETAIL_LEVEL_OPTIONS.SUMMARY);
        default:
          return '';
      }
    }
  }, {
    key: "getTaxCategoryExemptionFromName",
    value: function getTaxCategoryExemptionFromName(taxExemption) {
      var taxCategoryExemption = this.state.taxCategoryExemptions.find(function (taxCategoryExemption) {
        return taxCategoryExemption.id === taxExemption;
      });
      return pathOr('', ['text'], taxCategoryExemption);
    }
  }, {
    key: "getTaxExemptionTypeText",
    value: function getTaxExemptionTypeText(taxExemption) {
      var code = this.state.taxLevelCodes.find(function (code) {
        return code.Id === "".concat(taxExemption.TaxLevelCode);
      });
      var type = this.state.taxExemptionTypes.find(function (type) {
        return type.Id === "".concat(taxExemption.TaxType);
      });
      var taxAssociationCode = this.state.taxAssociationCodes.find(function (type) {
        return type.Id === "".concat(taxExemption.TaxAssociationCode);
      });
      var state = this.state.homeCountriesStates.find(function (type) {
        return type.Id === "".concat(taxExemption.State);
      });
      var OverridePercentage = taxExemption.OverridePercentage !== null ? "/ ".concat(taxExemption.OverridePercentage, " %") : '';
      return "".concat(type ? type.Value : '', " / ").concat(code ? "".concat(code.Value) : '', " / ").concat(taxAssociationCode ? "".concat(taxAssociationCode.Value) : 'All', " / ").concat(state ? " ".concat(state.Value) : 'All', "  ").concat(OverridePercentage, " ");
    }
  }, {
    key: "getFriendlyName",
    value: function getFriendlyName(countryCode) {
      return getNameByCountryCode(this.state.languages, countryCode);
    }
  }, {
    key: "_retrieveCustomer",
    value: function _retrieveCustomer(init) {
      var getCustomerPromise;

      //Retrieving the customer will clear several properties used on the customer dashboard
      if (init && this.state.currentCustomer) {
        getCustomerPromise = Promise.resolve(this.state.currentCustomer);
      } else {
        getCustomerPromise = this.actions.retrieveCustomer(this.state.currentCustomerId);
      }
      return getCustomerPromise;
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this.state.isFetchingData || this.state.isLoadingInventory || this.state.isFetchingAccountStatusData || !this.state.isExternalAuthorizationLoaded || this.showLoadingIndicator || this.state.isRetrievingBillCycleDetails;
    }
  }, {
    key: "viewMandatoryConsents",
    value: function viewMandatoryConsents() {
      this.mandatoryConsentsPopupApi.open();
    }
  }, {
    key: "openCreditCheckModal",
    value: function openCreditCheckModal() {
      this.showCreditCheckModal = true;
    }
  }, {
    key: "closeCreditCheckModal",
    value: function closeCreditCheckModal() {
      this.showCreditCheckModal = false;
    }
  }, {
    key: "closeMandatoryConsentsPopup",
    value: function closeMandatoryConsentsPopup() {
      this.mandatoryConsentsPopupApi.close();
    }
  }, {
    key: "saveCreditCheckModal",
    value: function saveCreditCheckModal() {}
  }, {
    key: "setCustomerTypeChangeReadOnly",
    value: function setCustomerTypeChangeReadOnly() {
      var alreadyHasCreditCheckClassification = !!this.state.currentCustomer.CreditCheckClassification;
      var hasEditTypeAccess = hasAccess(this.state.userSecurityAttributes, SUBSCRIBER_TYPE_EDIT_ACCESS);
      this.isCustomerTypeChangeReadOnly = alreadyHasCreditCheckClassification && !hasEditTypeAccess && !this.state.isCreatingCustomer;
    }
  }, {
    key: "onCreditCheckModalSuccess",
    value: function onCreditCheckModalSuccess() {
      var _this13 = this;
      this._retrieveCustomer(false).then(function () {
        _this13.setCustomerTypeChangeReadOnly();
      });
    }
  }, {
    key: "formatSubscriberIdentifications",
    value: function formatSubscriberIdentifications() {
      var _this14 = this;
      this.subscriberIdentifications = this.state.currentCustomer.SubscriberIdentifications ? this.state.currentCustomer.SubscriberIdentifications.map(function (customerIdentification) {
        var identification = _this14.state.subscriberIdentifications.find(function (subscriberIdentification) {
          return subscriberIdentification.Value === customerIdentification.SubscriberIdentificationTypeCode;
        }) || null;
        return {
          Name: identification.Name,
          SubscriberIdentificationValue: customerIdentification.SubscriberIdentificationValue
        };
      }) : [];
    }
  }, {
    key: "formatNotificationPreferences",
    value: function formatNotificationPreferences() {
      if (this.state.notificationCategoryPreference.length) {
        this.notificationPreferencesSection = this.state.notificationCategoryPreference.map(function (notificationCategory) {
          var optOutOptions = notificationCategory.optOutOptions.map(function (option) {
            return option.label;
          }).join(', ');
          return {
            customerNotificationCategoryId: notificationCategory.customerNotificationCategoryId,
            customerNotificationCategoryName: notificationCategory.customerNotificationCategoryName,
            customerNotificationCategoryOptOutOptions: optOutOptions
          };
        });
      }
    }
  }]);
}();
export default {
  controller: CustomerProfileController,
  controllerAs: 'CustomerProfileController',
  template: require('./profile.html')
};